webpackJsonp([1],Array(29).concat([
/* 29 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_VUBall__ = __webpack_require__(56);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app',
  components: {
    VUBall: __WEBPACK_IMPORTED_MODULE_0__components_VUBall__["a" /* default */]
  },

  data: function data() {
    return {
      canStart: false
    };
  },
  mounted: function mounted() {
    console.log('app started');
  },

  methods: {
    setupContext: function setupContext() {
      var _this = this;

      // monkeypatch Web Audio
      window.AudioContext = window.AudioContext || window.webkitAudioContext || null;

      if (!AudioContext) {
        console.error('THERE IS NO AUDIO CONTEXT HERE!  FULL STOP, BABY');
        return;
      }
      // grab an audio context
      window.audioContext = new AudioContext();

      // // Attempt to get audio input
      // try {
      //   // ask for an audio input
      //   navigator.getUserMedia(
      //     {
      //       audio: true,
      //       video: false,
      //     },
      //     this.gotStream,
      //     this.didntGetStream,
      //   );
      // } catch (e) {
      //   console.log(`getUserMedia threw exception :${e}`);
      // }


      navigator.mediaDevices.getUserMedia({ audio: true, video: false }).then(function (stream) {
        console.log('gotStream started');

        // Create an AudioNode from the stream.
        window.userMediaStreamSource = window.audioContext.createMediaStreamSource(stream);

        _this.canStart = true;
      }).catch(function (inErr) {
        console.log('Stream generation failed.');
        console.log(inErr);
      });
    },
    didntGetStream: function didntGetStream() {
      console.log('Stream generation failed.');
    },
    gotStream: function gotStream(stream) {
      console.log('gotStream started');

      // Create an AudioNode from the stream.
      window.userMediaStreamSource = window.audioContext.createMediaStreamSource(stream);

      this.canStart = true;
    }
  }
});

/***/ }),
/* 30 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__js_volume_meter__ = __webpack_require__(31);
//
//
//
//

// helpful web audio math


function mapRange(value, low1, high1, low2, high2) {
  // helpful function taken from Processing + P5 lands...
  // eslint-disable-next-line no-mixed-operators
  return low2 + (high2 - low2) * (value - low1) / (high1 - low1);
}

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'VUBall',
  data: function data() {
    return {
      vol: 0,
      volScaler: 60,
      mediaStreamSource: null,
      audioContext: null
    };
  },

  computed: {
    ballScall: function ballScall() {
      return mapRange(this.vol, 0.0, 2.0, 0.5, 1.0);
    }
  },
  mounted: function mounted() {
    var _this = this;

    var intervalCount = 0;
    var int = setInterval(function () {
      console.log('blocking for userMediaStreamSource');
      intervalCount += 1;
      if (window.userMediaStreamSource) {
        clearInterval(int);
        console.log('stream source acquired!  moving on');
        _this.bewmAudio();
      } else if (intervalCount > 300) {
        clearInterval(int);
        console.log('waited for context for 6 seconds, giving up....');
      }
    }, 300);
  },

  methods: {
    bewmAudio: function bewmAudio() {
      console.log('bewmAudio started');

      // Create a new volume meter and connect it.
      this.meter = Object(__WEBPACK_IMPORTED_MODULE_0__js_volume_meter__["a" /* createAudioMeter */])(window.audioContext);
      window.userMediaStreamSource.connect(this.meter);

      // kick off the visual updating
      this.drawLoop();
    },
    drawLoop: function drawLoop() {
      // console.log('drawLoop started');
      this.vol = this.meter.volume * this.volScaler;
      // efficient loop
      window.requestAnimationFrame(this.drawLoop);
    }
  }
});

/***/ }),
/* 31 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export volumeAudioProcess */
/* harmony export (immutable) */ __webpack_exports__["a"] = createAudioMeter;
/*
The MIT License (MIT)

Copyright (c) 2014 Chris Wilson

Modified by Spencer Cap @ 01-29-2020

*/

function volumeAudioProcess(event) {
  var buf = event.inputBuffer.getChannelData(0);
  var bufLength = buf.length;
  var sum = 0;
  var x = void 0;

  // Do a root-mean-square on the samples: sum up the squares...
  // eslint-disable-next-line no-plusplus
  for (var i = 0; i < bufLength; i++) {
    x = buf[i];
    if (Math.abs(x) >= this.clipLevel) {
      this.clipping = true;
      this.lastClip = window.performance.now();
    }
    sum += x * x;
  }

  // ... then take the square root of the sum.
  var rms = Math.sqrt(sum / bufLength);

  // Now smooth this out with the averaging factor applied
  // to the previous sample - take the max here because we
  // want "fast attack, slow release."
  this.volume = Math.max(rms, this.volume * this.averaging);
}

function createAudioMeter(audioContext, clipLevel, averaging, clipLag) {
  var _this = this;

  var processor = audioContext.createScriptProcessor(512);
  processor.onaudioprocess = volumeAudioProcess;
  processor.clipping = false;
  processor.lastClip = 0;
  processor.volume = 0;
  processor.clipLevel = clipLevel || 0.98;
  processor.averaging = averaging || 0.95;
  processor.clipLag = clipLag || 750;

  // this will have no effect, since we don't copy the input to the output,
  // but works around a current Chrome bug.
  processor.connect(audioContext.destination);

  processor.checkClipping = function () {
    if (!_this.clipping) {
      return false;
    }
    if (_this.lastClip + _this.clipLag < window.performance.now()) {
      _this.clipping = false;
    }
    return _this.clipping;
  };

  processor.shutdown = function () {
    _this.disconnect();
    _this.onaudioprocess = null;
  };

  return processor;
}

/***/ }),
/* 32 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'hello',
  data: function data() {
    return {
      msg: 'Welcome to VOS...'
    };
  }
});

/***/ }),
/* 33 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tone__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_tone__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_FilterBall__ = __webpack_require__(67);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import pizzicato from 'pizzicato';

// import RealTimeBPMAnalyzer from '@/js/bpm/index';


var COMMANDS = {
  recordDrums: 'RECORD DRUMS',
  recordBass: 'RECORD BASS',
  recordMelody: 'RECORD MELODY',
  recordAudio: 'RECORD AUDIO'
};

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'recorder',
  components: {
    FilterBall: __WEBPACK_IMPORTED_MODULE_1__components_FilterBall__["a" /* default */]
  },
  data: function data() {
    var _this = this;

    return {
      msg: 'Welcome to VOS Recorder... do we have an audio context?',
      playing: false,
      command: '',
      bassDrumAmp: 0,
      snareDrumAmp: 0,
      snareDrum: new __WEBPACK_IMPORTED_MODULE_0_tone___default.a.Player('/static/sounds/drums/808/SD0010.WAV').toMaster(),
      metronomeStarted: false,
      metronomePart: new __WEBPACK_IMPORTED_MODULE_0_tone___default.a.Part(function (time, note) {
        // the notes given as the second element in the array
        // will be passed in as the second argument
        console.log('trigger?');
        _this.synth.triggerAttackRelease(note, '8n', time);
      }, [[0, 'C2'], ['0:2', 'C3'], ['0:3:2', 'G2']]),
      playPause: 'Play with metronome',
      synth: new __WEBPACK_IMPORTED_MODULE_0_tone___default.a.Synth().toMaster(),
      snareSynth: new __WEBPACK_IMPORTED_MODULE_0_tone___default.a.Synth().toMaster(),
      snarePart: new __WEBPACK_IMPORTED_MODULE_0_tone___default.a.Part(function (time, note) {
        // this.snareSynth.triggerAttackRelease(note, '32n', time);
        _this.snareDrum.start(time);
      }, []),
      eventAdding: false
    };
  },

  methods: {

    // addNote(inNote) {

    // },

    bassDrumEvent: function bassDrumEvent(inVolume) {
      if (inVolume > 0.1) {
        this.bassDrumAmp = inVolume;
      }
    },
    snareDrumEvent: function snareDrumEvent(inVolume) {
      var _this2 = this;

      if (inVolume > 0.1 && !this.eventAdding) {
        this.eventAdding = true;
        this.snareDrumAmp = inVolume;

        console.log(__WEBPACK_IMPORTED_MODULE_0_tone___default.a.Transport.position);
        var barsBeats = __WEBPACK_IMPORTED_MODULE_0_tone___default.a.Transport.position.split(':');
        var clockPosition = '0:' + barsBeats[1] + ':' + (Math.floor(barsBeats[2]) - 1);
        this.snarePart.add(clockPosition, 'C5');
        console.log('rendering at ' + clockPosition);

        setTimeout(function () {
          _this2.eventAdding = false;
        }, 200);
      }
    },
    processCommand: function processCommand() {
      console.log('processing test command!');
      console.log(this.command);

      if (this.command.toUpperCase().startsWith(COMMANDS.recordDrums)) {
        this.msg = 'record drums command';

        // const scriptProcessorNode = window.audioContext.createScriptProcessor(4096, 1, 1);
        // // Connect everything together
        // scriptProcessorNode.connect(window.audioContext.destination);
        // window.userMediaStreamSource.connect(scriptProcessorNode);
        // window.userMediaStreamSource.connect(window.audioContext.destination);
        // const onAudioProcess = new RealTimeBPMAnalyzer({
        //   scriptNode: {
        //     bufferSize: 4096,
        //     continuousAnalysis: true,
        //     computeBPMDelay: 1000,
        //     stabilizationTime: 1000,
        //     numberOfInputChannels: 1,
        //     numberOfOutputChannels: 1,
        //   },
        //   pushTime: 1000,
        //   pushCallback: (err, bpm) => {
        //     console.log('push callback');

        //     if (err) {
        //       console.log(err);
        //     } else if (bpm) {
        //       this.msg = `detect BPM: ${bpm[0].tempo}`;
        //       console.log(bpm);
        //     }
        //   },
        // });
        // // Attach realTime function to audioprocess event.inputBuffer (AudioBuffer)
        // scriptProcessorNode.onaudioprocess = (e) => {
        //   onAudioProcess.analyze(e);
        // };
      } else if (this.command.toUpperCase().startsWith(COMMANDS.recordBass)) {
        this.msg = 'record bass command';
      } else if (this.command.toUpperCase().startsWith(COMMANDS.recordMelody)) {
        this.msg = 'record melody command';
      } else if (this.command.toUpperCase().startsWith(COMMANDS.recordAudio)) {
        this.msg = 'record AUDIO command';
      } else {
        this.msg = 'unknown command: try record audio, record drums, etc';
      }
      this.command = '';
    },
    startMetronome: function startMetronome() {
      if (this.metronomeStarted) {
        console.log('stopping metronome');
        this.metronomePart.stop();
        this.snarePart.stop();
        this.playPause = 'PLAY with metronome';
        this.metronomeStarted = false;
        this.transport.stop();
      } else {
        console.log('starting metronome');
        this.metronomeStarted = true;
        this.playPause = 'PAUSE with metronome';

        this.metronomePart.loop = true;
        this.metronomePart.start(0);
        this.snarePart.loop = true;
        this.snarePart.start(0);
        this.transport.start();
      }

      // const loop = new Tone.Loop((time) => {
      //   synth.triggerAttackRelease('a#2', '8n', time);
      // }, '1n');

      // const loop2 = new Tone.Loop((time) => {
      //   synth2.triggerAttackRelease('c#4', '2n', time);
      // }, '2n');

      // const snareDrum = new Tone.Player(
      //   '/static/sounds/drums/808/SD0010.WAV',
      // ).toMaster();

      // const loop3 = new Tone.Loop((time) => {
      //   snareDrum.start(time);
      // }, '2n');

      // loop.start();
      // loop2.start();

      // loop3.humanize = true;
      // loop3.start();

      // if (this.playing) {
      //   this.playing = false;
      //   Tone.Transport.stop();
      // } else {
      //   this.playing = true;
      //   Tone.Transport.start();
      // }

      // analyze(snareDrum.buffer)
      //   .then((tempo) => {
      //     console.log('analyze from snare is back');
      //     console.log(tempo);
      //   })
      //   .catch((err) => {
      //     console.log('analyze blew up, sad panda.');
      //     console.error(err);
      //   });

      // const freqs = [
      //   3729.31,
      //   3322.438,
      //   2959.955,
      //   2489.016,
      //   2217.461,
      //   1864.655,
      //   1661.219,
      //   1479.978,
      //   1244.508,
      //   1108.731,
      //   932.3275,
      //   932.3275,
      //   739.9888,
      //   622.254,
      //   554.3653,
      //   466.1638,
      //   415.3047,
      //   369.9944,
      //   311.127,
      //   277.1826,
      //   233.0819,
      //   207.6523,
      //   184.9972,
      //   155.5635,
      //   138.5913,
      //   116.5409,
      //   103.8262,
      //   92.49861,
      //   77.78175,
      // ];
      // const val = freqs[Math.floor(Math.random() * freqs.length)];
      // const sawtoothWave = new pizzicato.Sound({
      //   source: 'wave',
      //   options: {
      //     type: 'sawtooth',
      //     frequency: val,
      //   },
      // });
      // const delay = new pizzicato.Effects.Delay({
      //   feedback: 0.8,
      //   time: 0.22,
      //   mix: 0.75,
      // });
      // sawtoothWave.addEffect(delay);
      // sawtoothWave.play();
      // setTimeout(() => {
      //   sawtoothWave.stop();
      // }, 500);
    }
  },
  mounted: function mounted() {
    console.log('ok, recorder is mounted');

    this.transport = __WEBPACK_IMPORTED_MODULE_0_tone___default.a.Transport;

    // const sawtoothWave = new pizzicato.Sound({
    //   source: 'wave',
    //   options: {
    //     type: 'sawtooth',
    //     frequency: 92.49861,
    //   },
    // });

    // const delay = new pizzicato.Effects.Delay({
    //   feedback: 0.8,
    //   time: 0.22,
    //   mix: 0.75,
    // });
    // sawtoothWave.addEffect(delay);

    // sawtoothWave.play(2, 4);
    // setTimeout(() => {
    //   sawtoothWave.stop();
    // }, 3000);
  }
});

/***/ }),
/* 34 */,
/* 35 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__js_volume_meter__ = __webpack_require__(31);

//
//
//
//

// helpful web audio math


function mapRange(value, low1, high1, low2, high2) {
  // helpful function taken from Processing + P5 lands...
  // eslint-disable-next-line no-mixed-operators
  return low2 + (high2 - low2) * (value - low1) / (high1 - low1);
}

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'FilterBall',
  props: {
    center: {
      type: Number
    },
    color: {
      type: String
    },
    filter: {
      type: String
    }

  },
  data: function data() {
    return {
      vol: 0,
      volScaler: 60,
      mediaStreamSource: null,
      audioContext: null
    };
  },

  computed: {
    ballScall: function ballScall() {
      return mapRange(this.vol, 0.0, 2.0, 0.5, 1.0);
    }
  },
  mounted: function mounted() {
    var _this = this;

    var intervalCount = 0;
    var int = setInterval(function () {
      console.log('blocking for userMediaStreamSource');
      intervalCount += 1;
      if (window.userMediaStreamSource) {
        clearInterval(int);
        console.log('stream source acquired!  moving on');
        _this.startFilterBall();
      } else if (intervalCount > 300) {
        clearInterval(int);
        console.log('waited for context for 6 seconds, giving up....');
      }
    }, 300);
  },

  methods: {
    findPeak: function findPeak(array) {
      var peak = 0;
      array.forEach(function (value) {
        peak = Math.max(peak, Math.abs(value));
      });
      return peak;
    },
    startFilterBall: function startFilterBall() {
      console.log('startFilterBall called ' + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(this.center));

      var biquadFilter = window.audioContext.createBiquadFilter();
      biquadFilter.type = this.filter;
      biquadFilter.frequency.value = this.center;
      biquadFilter.Q.value = 10;

      // const gainNode = window.audioContext.createGain();
      // gainNode.gain.value = 2.5;

      // Create a new volume meter and connect it.
      this.meter = Object(__WEBPACK_IMPORTED_MODULE_1__js_volume_meter__["a" /* createAudioMeter */])(window.audioContext);

      window.userMediaStreamSource.connect(biquadFilter);
      // biquadFilter.connect(window.audioContext.destination);
      biquadFilter.connect(this.meter);
      // gainNode.connect(window.audioContext.destination);

      // gainNode.connect(this.meter);

      this.meter.connect(window.audioContext.destination);

      // kick off the visual updating
      this.drawLoop();
    },
    drawLoop: function drawLoop() {
      // console.log('drawLoop started');
      this.vol = this.meter.volume * this.volScaler;
      this.$emit('volume', this.meter.volume);
      // efficient loop
      window.requestAnimationFrame(this.drawLoop);
    }
  }
});

/***/ }),
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tone__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_tone__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_annyang__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_annyang___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_annyang__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import pizzicato from 'pizzicato';


// import { analyze } from 'web-audio-beat-detector';

var COMMANDS = {
  recordDrums: 'RECORD DRUMS',
  recordBass: 'RECORD BASS',
  recordMelody: 'RECORD MELODY',
  recordAudio: 'RECORD AUDIO'
};

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Looper',
  data: function data() {
    return {
      msg: 'reactivity + voice input playground',
      playing: false,
      command: '',
      bpm: 120,
      loop4: undefined,

      instrumentTrack: 'drums'
    };
  },

  watch: {
    bpm: function bpm(newBpm) {
      __WEBPACK_IMPORTED_MODULE_0_tone___default.a.Transport.bpm.value = newBpm;
    }
  },
  methods: {
    processCommand: function processCommand() {
      console.log('processing test command!');
      console.log(this.command);

      if (this.command.toUpperCase().startsWith(COMMANDS.recordDrums)) {
        this.msg = 'record drums command';
      } else if (this.command.toUpperCase().startsWith(COMMANDS.recordBass)) {
        this.msg = 'record bass command';
      } else if (this.command.toUpperCase().startsWith(COMMANDS.recordMelody)) {
        this.msg = 'record melody command';
      } else if (this.command.toUpperCase().startsWith(COMMANDS.recordAudio)) {
        this.msg = 'record AUDIO command';
      } else {
        this.msg = 'unknown command: try record audio, record drums, etc';
      }
      this.command = '';
    },
    playTest: function playTest() {
      // create a synth and connect it to the master output (your speakers)
      var synth = new __WEBPACK_IMPORTED_MODULE_0_tone___default.a.Synth().toMaster();
      var synth2 = new __WEBPACK_IMPORTED_MODULE_0_tone___default.a.Synth().toMaster();

      var delay = new __WEBPACK_IMPORTED_MODULE_0_tone___default.a.FeedbackDelay('8n', 0.75).toMaster();

      synth.connect(delay);

      // play a middle 'C' for the duration of an 8th note
      // synth.triggerAttackRelease('C3', '8n');

      var loop = new __WEBPACK_IMPORTED_MODULE_0_tone___default.a.Loop(function (time) {
        synth.triggerAttackRelease('a#2', '8n', time);
      }, '1n');

      var loop2 = new __WEBPACK_IMPORTED_MODULE_0_tone___default.a.Loop(function (time) {
        synth2.triggerAttackRelease('c#4', '2n', time);
      }, '2n');

      var snareDrum = new __WEBPACK_IMPORTED_MODULE_0_tone___default.a.Player('/static/sounds/drums/808/SD0010.WAV').toMaster();

      var loop3 = new __WEBPACK_IMPORTED_MODULE_0_tone___default.a.Loop(function (time) {
        // console.log(time);
        snareDrum.start(time);
      }, '2n');

      // eslint-disable-next-line no-unused-vars
      var seq = new __WEBPACK_IMPORTED_MODULE_0_tone___default.a.Sequence(function (time, step) {
        // console.log(step); // step
      }, [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15], '16n');

      seq.stop();
      seq.start(0);

      loop.start();
      loop2.start();

      loop3.humanize = true;
      loop3.start();

      if (this.playing) {
        this.playing = false;
        __WEBPACK_IMPORTED_MODULE_0_tone___default.a.Transport.stop();
      } else {
        this.playing = true;
        __WEBPACK_IMPORTED_MODULE_0_tone___default.a.Transport.start();
      }

      // analyze(snareDrum.buffer)
      //   .then((tempo) => {
      //     console.log('analyze from snare is back');
      //     console.log(tempo);
      //   })
      //   .catch((err) => {
      //     console.log('analyze blew up, sad panda.');
      //     console.error(err);
      //   });

      // const freqs = [
      //   3729.31,
      //   3322.438,
      //   2959.955,
      //   2489.016,
      //   2217.461,
      //   1864.655,
      //   1661.219,
      //   1479.978,
      //   1244.508,
      //   1108.731,
      //   932.3275,
      //   932.3275,
      //   739.9888,
      //   622.254,
      //   554.3653,
      //   466.1638,
      //   415.3047,
      //   369.9944,
      //   311.127,
      //   277.1826,
      //   233.0819,
      //   207.6523,
      //   184.9972,
      //   155.5635,
      //   138.5913,
      //   116.5409,
      //   103.8262,
      //   92.49861,
      //   77.78175,
      // ];
      // const val = freqs[Math.floor(Math.random() * freqs.length)];
      // const sawtoothWave = new pizzicato.Sound({
      //   source: 'wave',
      //   options: {
      //     type: 'sawtooth',
      //     frequency: val,
      //   },
      // });
      // const delay = new pizzicato.Effects.Delay({
      //   feedback: 0.8,
      //   time: 0.22,
      //   mix: 0.75,
      // });
      // sawtoothWave.addEffect(delay);
      // sawtoothWave.play();
      // setTimeout(() => {
      //   sawtoothWave.stop();
      // }, 500);
    }
  },
  mounted: function mounted() {
    var _this = this;

    console.log('Looper mounted');

    if (__WEBPACK_IMPORTED_MODULE_1_annyang___default.a) {
      console.log('annyang loaded');
      var commands = {
        'hello world': function helloWorld() {
          console.log('hello world!');
        },
        'something unique': function somethingUnique() {
          console.log('mo unique mo better?');
        },
        potatoe: function potatoe() {
          console.log('potatoe!');
        },

        'change to the :instrument track': function changeToTheInstrumentTrack(instrument) {
          console.log('change to ' + instrument + ' track');
          _this.instrumentTrack = instrument;
        }
      };
      __WEBPACK_IMPORTED_MODULE_1_annyang___default.a.addCommands(commands);
      __WEBPACK_IMPORTED_MODULE_1_annyang___default.a.start();
      // annyang.resume();

      __WEBPACK_IMPORTED_MODULE_1_annyang___default.a.addCallback('soundstart', function (x) {
        console.log('sound started! ' + x);
      });
    } else {
      console.log('no annyang');
    }
  },
  beforeDestroy: function beforeDestroy() {
    __WEBPACK_IMPORTED_MODULE_1_annyang___default.a.pause();
  }
});

/***/ }),
/* 48 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_resonance_audio__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_resonance_audio___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_resonance_audio__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Spatial',
  data: function data() {
    return {
      msg: 'Spatial playground',
      mediaStreamSource: null,

      audioContext: null,

      // google resonance
      resonanceAudioScene: null,
      source: null,
      sourcePosition: {
        x: -0.707,
        y: -0.707,
        z: 0
      },
      room: {
        // sizes in meters (m)
        dimensions: {
          width: 3.1,
          height: 2.5,
          depth: 3.4
        },
        // for rooms 6 walls
        materials: {
          left: 'brick-bare',
          right: 'brick-bare',
          front: 'brick-bare',
          back: 'brick-bare',
          down: 'grass', // floor
          up: 'transparent' // ceiling
        }
      }
    };
  },
  mounted: function mounted() {
    this.setupAudio();
  },

  watch: {
    sourcePosition: {
      handler: function handler() {
        this.updateSourcePosition();
      },

      deep: true
    }
  },
  methods: {
    setupAudio: function setupAudio() {
      // get webaudio
      window.AudioContext = window.AudioContext || window.webkitAudioContext;
      // create audio context
      this.audioContext = new AudioContext();
      // Create a (first-order Ambisonic) Resonance Audio scene and pass it the AudioContext.
      this.resonanceAudioScene = new __WEBPACK_IMPORTED_MODULE_0_resonance_audio__["ResonanceAudio"](this.audioContext, { ambisonicOrder: 3 });
      // Connect the scene’s binaural output to stereo out.
      this.resonanceAudioScene.output.connect(this.audioContext.destination);
      // Add the room definition to the scene.
      this.resonanceAudioScene.setRoomProperties(this.room.dimensions, this.room.materials);

      /* sound setup */
      // Create an AudioElement or grab one from the DOM
      // const audioElement = document.createElement('audio');
      var audioElement = document.querySelector('#song');
      // Generate a MediaElementSource from the AudioElement.
      var audioElementSource = this.audioContext.createMediaElementSource(audioElement);
      // Add the MediaElementSource to the scene as an audio input source.
      this.source = this.resonanceAudioScene.createSource();
      audioElementSource.connect(this.source.input);
      // Set the source position relative to the room center (source default position).
      this.source.setPosition(this.sourcePosition.x, this.sourcePosition.y, this.sourcePosition.z);
    },
    updateSourcePosition: function updateSourcePosition() {
      this.source.setPosition(this.sourcePosition.x, this.sourcePosition.y, this.sourcePosition.z);
    }
  }
});

/***/ }),
/* 49 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(60);
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.




__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;

window.VosCtx = {
  acceptCommand: function acceptCommand(inCommand) {
    console.log('in command! ' + inCommand);

    // The Vos object is  injected from the flutter shell
    // ESLint doesn't know how to deal with this so...
    // eslint-disable-next-line
    if (Vos && inCommand && inCommand !== "unknown") {
      // eslint-disable-next-line
      Vos.postMessage('web got command: ' + inCommand);
    }
  }
};

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].prototype.$VosCtx = window.VosCtx;

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].prototype.$UserMediaStreamSource = null;

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_1__App__["a" /* default */] }
});

/***/ }),
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__(29);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3e8ab94f_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__(59);
function injectStyle (ssrContext) {
  __webpack_require__(54)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3e8ab94f_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 54 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 55 */,
/* 56 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VUBall_vue__ = __webpack_require__(30);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8ba73df2_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VUBall_vue__ = __webpack_require__(58);
function injectStyle (ssrContext) {
  __webpack_require__(57)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-8ba73df2"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VUBall_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8ba73df2_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VUBall_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 57 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 58 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ball",style:(("transform: scale(" + (this.ballScall) + ")"))})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 59 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('header',{staticClass:"d-flex justify-space-between align-center"},[_c('span',[_vm._v("\n      . x VOS x .\n      "),_c('router-link',{staticStyle:{"color":"white"},attrs:{"to":"/rcrdr"}},[_vm._v("Rcrdr")]),_vm._v(" "),_c('router-link',{staticStyle:{"color":"white"},attrs:{"to":"/loopr"}},[_vm._v("Loopr")]),_vm._v(" "),_c('router-link',{staticStyle:{"color":"white"},attrs:{"to":"/space"}},[_vm._v("Space")])],1),_vm._v(" "),_c('VUBall')],1),_vm._v(" "),_c('main',[(_vm.canStart)?_c('router-view'):_c('div',{staticClass:"modal-starter"},[_c('button',{on:{"click":function($event){return _vm.setupContext()}}},[_vm._v("Start Kicking Ass")])])],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 60 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Hello__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Recorder__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Loop__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Spatial__ = __webpack_require__(105);







__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  routes: [{
    path: '/',
    name: 'Hello',
    component: __WEBPACK_IMPORTED_MODULE_2__components_Hello__["a" /* default */]
  }, {
    path: '/rcrdr',
    name: 'Vos Recorder',
    component: __WEBPACK_IMPORTED_MODULE_3__components_Recorder__["a" /* default */]
  }, {
    path: '/loopr',
    name: 'Vos Looper',
    component: __WEBPACK_IMPORTED_MODULE_4__components_Loop__["a" /* default */]
  }, {
    path: '/space',
    name: 'Spatial',
    component: __WEBPACK_IMPORTED_MODULE_5__components_Spatial__["a" /* default */]
  }]
}));

/***/ }),
/* 61 */,
/* 62 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Hello_vue__ = __webpack_require__(32);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8f9baf06_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Hello_vue__ = __webpack_require__(64);
function injectStyle (ssrContext) {
  __webpack_require__(63)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Hello_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8f9baf06_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Hello_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 63 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 64 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"hello"},[_c('h1',[_vm._v(_vm._s(_vm.msg))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 65 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Recorder_vue__ = __webpack_require__(33);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f44007d4_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Recorder_vue__ = __webpack_require__(100);
function injectStyle (ssrContext) {
  __webpack_require__(66)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Recorder_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f44007d4_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Recorder_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 66 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 67 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FilterBall_vue__ = __webpack_require__(35);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_59d9f243_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FilterBall_vue__ = __webpack_require__(99);
function injectStyle (ssrContext) {
  __webpack_require__(68)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-59d9f243"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FilterBall_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_59d9f243_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FilterBall_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 68 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ball",style:(("transform: scale(" + (this.ballScall) + "); background: " + (this.color) + ";"))})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 100 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"recorder"},[_vm._v("\n  Test Command\n  "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.command),expression:"command"}],attrs:{"placeholder":"enter test command"},domProps:{"value":(_vm.command)},on:{"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.processCommand($event)},"input":function($event){if($event.target.composing){ return; }_vm.command=$event.target.value}}}),_vm._v(" "),_c('button',{on:{"click":_vm.processCommand}},[_vm._v("GO!")]),_vm._v(" "),_c('h1',[_vm._v(_vm._s(_vm.msg))]),_vm._v(" "),_c('div',[_c('button',{on:{"click":function($event){return _vm.startMetronome()}}},[_vm._v(_vm._s(_vm.playPause))])]),_vm._v(" "),_c('div',[_vm._v("Bass Drum Volume: "+_vm._s(_vm.bassDrumAmp))]),_vm._v(" "),_c('div',[_vm._v("Snare Drum Volume: "+_vm._s(_vm.snareDrumAmp))]),_vm._v(" "),_c('div',[_c('filter-ball',{attrs:{"center":90,"color":"#FF0000","filter":"lowpass"},on:{"volume":_vm.bassDrumEvent}}),_vm._v(" "),_c('filter-ball',{attrs:{"center":160,"color":"#00FF00","filter":"bandpass"}}),_vm._v(" "),_c('filter-ball',{attrs:{"center":6000,"color":"#0000FF","filter":"highpass"},on:{"volume":_vm.snareDrumEvent}})],1),_vm._v(" "),_vm._m(0)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('audio',{attrs:{"id":"song","src":"/static/sounds/Clap Clap - Flowing Like a Snake in Ophiuchus Arms.mp3","controls":""}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 101 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Loop_vue__ = __webpack_require__(47);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_33d10c03_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Loop_vue__ = __webpack_require__(104);
function injectStyle (ssrContext) {
  __webpack_require__(102)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Loop_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_33d10c03_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Loop_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 102 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 103 */,
/* 104 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"hello"},[_c('h1',[_vm._v(_vm._s(_vm.msg))]),_vm._v(" "),_c('div',{staticClass:"vert"},[_c('div',[_c('label',{attrs:{"for":"bpmInput"}},[_vm._v("BPM (reactive)")]),_vm._v(" "),_c('div',{staticClass:"d-flex justify-center"},[_c('button',{on:{"click":function($event){_vm.bpm--}}},[_vm._v("-")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.bpm),expression:"bpm"}],attrs:{"id":"bpmInput","type":"number","placeholder":"120"},domProps:{"value":(_vm.bpm)},on:{"input":function($event){if($event.target.composing){ return; }_vm.bpm=$event.target.value}}}),_vm._v(" "),_c('button',{on:{"click":function($event){_vm.bpm++}}},[_vm._v("+")])])]),_vm._v(" "),_c('button',{on:{"click":function($event){return _vm.playTest()}}},[_vm._v(_vm._s(_vm.playing ? 'Pause' : 'Play'))]),_vm._v(" "),_c('div',[_c('span',[_vm._v("Track")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.instrumentTrack),expression:"instrumentTrack"}],on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.instrumentTrack=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":"drums"}},[_vm._v("drums")]),_vm._v(" "),_c('option',{attrs:{"value":"base"}},[_vm._v("bass")]),_vm._v(" "),_c('option',{attrs:{"value":"synth"}},[_vm._v("synth")])]),_vm._v(" "),_c('div',[_vm._v("\n          Say \"change to the X track\"\n        ")])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 105 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Spatial_vue__ = __webpack_require__(48);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_73b7ebc6_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Spatial_vue__ = __webpack_require__(108);
function injectStyle (ssrContext) {
  __webpack_require__(106)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-73b7ebc6"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Spatial_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_73b7ebc6_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Spatial_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 106 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 107 */,
/* 108 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{},[_c('h1',[_vm._v(_vm._s(_vm.msg))]),_vm._v(" "),_c('p',[_vm._v("powered by Google resonance")]),_vm._v(" "),_c('div',{staticClass:"soundContainer d-flex flex-column align-start"},[_c('h4',{staticClass:"title"},[_vm._v("Playback audio track")]),_vm._v(" "),_c('audio',{attrs:{"id":"song","src":"/static/sounds/Clap Clap - Flowing Like a Snake in Ophiuchus Arms.mp3","controls":""}}),_vm._v(" "),_c('h4',[_vm._v("XYZ Settings")]),_vm._v(" "),_c('label',{attrs:{"for":"X"}},[_vm._v("X (left-right): "+_vm._s(_vm.sourcePosition.x)+" ")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.sourcePosition.x),expression:"sourcePosition.x"}],attrs:{"id":"X","type":"range","min":"-5","max":"5","step":"0.001"},domProps:{"value":(_vm.sourcePosition.x)},on:{"__r":function($event){return _vm.$set(_vm.sourcePosition, "x", $event.target.value)}}}),_vm._v(" "),_c('label',{attrs:{"for":"Y"}},[_vm._v("Y (back-forward): "+_vm._s(_vm.sourcePosition.y)+" ")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.sourcePosition.y),expression:"sourcePosition.y"}],attrs:{"id":"Y","type":"range","min":"-5","max":"5","step":"0.001"},domProps:{"value":(_vm.sourcePosition.y)},on:{"__r":function($event){return _vm.$set(_vm.sourcePosition, "y", $event.target.value)}}}),_vm._v(" "),_c('label',{attrs:{"for":"Z"}},[_vm._v("Z (low-high): "+_vm._s(_vm.sourcePosition.z)+" ")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.sourcePosition.z),expression:"sourcePosition.z"}],attrs:{"id":"Z","type":"range","min":"-5","max":"5","step":"0.001"},domProps:{"value":(_vm.sourcePosition.z)},on:{"__r":function($event){return _vm.$set(_vm.sourcePosition, "z", $event.target.value)}}})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })
]),[49]);


// WEBPACK FOOTER //
// static/js/app.fd2024c31e3872fd2121.js